import React from "react"
import IconDatePicker from "./IconDatePicker"
import * as payGroupAndTypeHelper from "../../helpers/payGroupAndTypeHelper"
import * as payrollHelper from "../../helpers/payrollHelper"
import { IDateRange, IDate, IPayrollPayGroupData, IPayrollPayCalendar } from "../../models"
import moment from "moment"

interface IProps {
    payPeriodReferenceDate: IDate
    payrollDataForPayGroup: IPayrollPayGroupData | IPayrollPayCalendar
    label: string
    readonly?: boolean
    selectedDate: IDate
    errorText?: string
    handleSelectDate(selectedDate: IDate)
}

export default class IconDatePickerForPayPeriod extends React.Component<IProps, {}>  {
    private payrollDate: IDateRange
    private payPeriodDayStartTime24Hour: number
    constructor(props: IProps) {
        super(props)
        if (props.payrollDataForPayGroup.hasOwnProperty("PayrollHierarchyItemId")) {
            const payrollPayGroupData: IPayrollPayGroupData = props.payrollDataForPayGroup as IPayrollPayGroupData
            const payGroup = payGroupAndTypeHelper.getPayGroupByPayrollPayGroupData(payrollPayGroupData)
            this.payrollDate = payrollHelper.getPayrollDates(props.payPeriodReferenceDate, payGroup.Id)
            this.payPeriodDayStartTime24Hour = payGroup.PaySettings.PayPeriodDayStartTime24Hour
        }
        else {
            const payrollPayCalendar: IPayrollPayCalendar = props.payrollDataForPayGroup as IPayrollPayCalendar
            this.payrollDate = payrollHelper.getPayrollDatesByPayCalendar(props.payPeriodReferenceDate, payrollPayCalendar)
            this.payPeriodDayStartTime24Hour = payrollPayCalendar.PayPeriodDayStartTime24Hour
        }
    }

    componentDidMount() {
        !this.props.selectedDate &&
            this.props.handleSelectDate(this.adjustPayPeriodDayStartTime24Hour(moment(this.payrollDate.EndDate).subtract(this.payPeriodDayStartTime24Hour, "hour")))
    }

    adjustPayPeriodDayStartTime24Hour(date: IDate): IDate {
        return moment(date).startOf("day").add(this.payPeriodDayStartTime24Hour, "hour").format()
    }

    render() {
        return (
            <IconDatePicker
                label={this.props.label}
                date={this.props.selectedDate}
                errorText={this.props.errorText}
                readonly={this.props.readonly}
                firstDayOfWeek={0}
                maxDate={moment(this.payrollDate.EndDate).add(-this.payPeriodDayStartTime24Hour, "hour")}
                minDate={moment(this.payrollDate.StartDate).add(-this.payPeriodDayStartTime24Hour, "hour")}
                handleSelectDate={date => this.props.handleSelectDate(this.adjustPayPeriodDayStartTime24Hour(date))}
            />
        )
    }
}
